import { type Dispatch, useCallback } from "react";
import EmailTemplateForm from "./EmailTemplateForm";
import Modal from "../Modal";

type PresenceSendModalProps = {
  year: number;
  month: number;
  onSendSuccess: () => void;
  dispatch: Dispatch<
    | {
        year: number;
        month: number;
      }
    | undefined
  >;
};
export default function PresenceSendModal({
  year,
  month,
  onSendSuccess,
  dispatch,
}: PresenceSendModalProps) {
  const showSomething = !!year && !!month;
  const abort = useCallback(() => dispatch(undefined), [dispatch]);
  return (
    <Modal open={showSomething} onClose={abort} size="medium">
      {showSomething && (
        <EmailTemplateForm
          year={year}
          month={month}
          triggerAnnulla={abort}
          triggerInvia={() => {
            onSendSuccess();
            abort();
          }}
        />
      )}
    </Modal>
  );
}
